<td class="py-(--space-2)">
  <div class="field-container flex flex-col">
    <div class="field-label select-none text-xs mb-(--space-1) text-(color:--text-secondary)">
      {{ 'common.labels.name' | transloco }}
    </div>
    <div class="field-value">{{ parameter.name }}</div>
  </div>
</td>

<td class="py-(--space-2)">
  <div class="field-container flex flex-col">
    <div class="field-label select-none text-xs mb-(--space-1) text-(color:--text-secondary)">
      {{ 'common.labels.symbol' | transloco }}
    </div>
    <div class="field-value uppercase">{{ parameter.symbol }}</div>
  </div>
</td>

<td class="py-(--space-2)">
  <div class="field-container flex flex-col">
    <div class="field-label select-none text-xs mb-(--space-1) text-(color:--text-secondary)">
      {{ 'common.labels.type' | transloco }}
    </div>
    <div class="field-value">{{ getTypeLabel(parameter.type) }}</div>
  </div>
</td>

@if (shouldShowUnit()) {
  <td>
    <div class="field-container flex flex-col">
      <div class="field-label select-none text-xs mb-(--space-1) text-(color:--text-secondary)">
        {{ shouldShowMeasureSelect() ? ('common.labels.unitMeasure' | transloco) : ('common.labels.unit' | transloco) }}
      </div>
      <div class="field-value">{{ getUnitLabel() }}</div>
    </div>
  </td>
}

@if (shouldShowMeasureSelect()) {
  <td class="py-(--space-2)">
    <div class="field-container flex flex-col">
      <div class="field-label select-none text-xs mb-(--space-1) text-(color:--text-secondary)">
        {{ 'common.labels.measure' | transloco }}
      </div>
      <div class="field-value">{{ getMeasureLabel() }}</div>
    </div>
  </td>
}

@if (!shouldShowUnit() && !shouldShowMeasureSelect()) {
  <td [attr.colspan]="mode === ParameterMode.FORMULA_MODEL || mode === ParameterMode.POLYNOMIAL_MODEL ? 1 : 2"></td>
}

@if (shouldShowUnit()) {
  <td class="py-(--space-2)">
    @if (isConstant() || (isInput() && SHOW_INPUT_DEFAULT_VALUE)) {
      <div class="field-container flex flex-col">
        <div class="field-label select-none text-xs mb-(--space-1) text-(color:--text-secondary)">
          {{ isInput() ? ('common.labels.defaultValue' | transloco) : ('common.labels.value' | transloco) }}
        </div>
        <div class="field-value">
          @if (isConstant()) {
            <span>{{ getConstantValue() }}</span>
          }
          @if (isInput()) {
            @if (hasDefaultValue()) {
              <span>{{ getDefaultValue() }}</span>
            } @else {
              <span class="text-(color:--text-secondary) text-sm">{{ 'common.labels.notDefined' | transloco }}</span>
            }
          }
        </div>
      </div>
    }
  </td>
}
